import moment from "moment";

const {mapState} = require("vuex");

export default {
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      user: {},
      title: "",
      icon_url: "",
      company_name: "",
      lastMessageUserId: ""
    }
  },
  mounted() {
    this.retrieveParams();
  },
  watch: {
    item: {
      handler() {
        this.retrieveParams();
      }
      ,
      deep: true
    },
    uxDocs: {
      handler() {
        this.retrieveParams();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      users: state => state.Chat.uxDocs,
      owner_id: state => state.Chat.owner_id,
      tenant_id: state => state.Chat.tenant_id,
      uxDocs: state => state.Chat.uxDocs,
    }),
    get_unread_message() {
      if (this.item && this.item.unread_counters) {
        return this.item.unread_counters[this.owner_id] || 0;
      }
      return 0;
    },
    participants() {
      let users = [];
      if (this.item && this.item.participants) {
        for (const participant of this.item.participants) {
          const user = this.users[participant.user_id];
          if (user) users.push(user);
        }
      }
      return users;
    }
  },
  methods: {
    retrieveParams() {
      if (this.item) {
        this.title = this.item.title;
        this.icon_url = this.item.icon_url;
        this.company_name = this.item.company_name;
        this.lastMessageUserId = this.item;
        this.user = this.item;

        // Kiey AI chats: synthesize a proper user record so both the title
        // and the avatar render correctly. Detect via the is_ai_chat flag
        // OR a participant ending in `/kiey-ai-assistant` (older chats
        // predate the flag).
        const looksAI = this.item.is_ai_chat
          || (this.item.participants && this.item.participants.some(p => p && p.user_id === 'kiey-ai-assistant'))
          || (this.item.participant_ids && this.item.participant_ids.some(p => typeof p === 'string' && p.endsWith('/kiey-ai-assistant')));
        if (!this.title && looksAI) {
          this.title = "Kiey AI";
          this.user = {
            id: 'kiey-ai-assistant',
            user_id: 'kiey-ai-assistant',
            user_role: 'ai_assistant',
            first_name: 'Kiey',
            last_name: 'AI',
          };
        }

        if (!this.title) {
          if (this.item.participants) {
            for (let o of this.item.participants) {
              if (o.user_id !== this.owner_id) {
                if (this.users[o.user_id]) {
                  this.title = this.users[o.user_id].first_name + " " + this.users[o.user_id].last_name;
                  this.icon_url = this.users[o.user_id].profile_picture;
                  this.company_name = this.users[o.user_id].company_name;
                  this.lastMessageUserId = this.users[o.user_id].id;
                  this.user = this.users[o.user_id];
                  break;
                }
              }
            }
          } else if (this.item.type === "contact") {
            this.title = this.item.first_name + " " + this.item.last_name;
            this.icon_url = this.item.profile_picture;
            this.company_name = this.item.company_name;
            this.lastMessageUserId = this.item.owner_id;
            this.user = this.item;
          } else if (this.item.type === "message") {
            const sender = this.users[this.item.owner_id];
            if (sender) {
              this.title = sender.first_name + " " + sender.last_name;
            }
          }
        }

        if (!this.title && this.item.status === "deleted") {
          // Only hide if already marked deleted — don't hide conversations still loading
        } else if (!this.title) {
          this.title = "Loading...";
        }
      }
    },
    agoDate: function (value) {
      if (value) {
        return moment(new Date(value)).fromNow();
      }
      return "";
    }
  }
}
;
